import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { setRecoil } from "recoil-nexus";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";

// component
import AuthForm from "../components/AuthForm";
import Button from "src/components/Button";

//query
import { getUserRole } from "src/Query/UserRole/userRole.query";
import { loginUser } from "src/Query/Auth/auth.mutation";

import { localStorageKey } from "src/constants/generics";
import { accountAtom } from "src/recoilState/account";
import { allRoutes } from "src/constants/AllRoutes";
import { setItem } from "src/utils/storage";
import { Strings } from "src/resources";
import LoginForm from "./LoginForm";

function Login() {
  const navigate = useNavigate();

  const { control, handleSubmit } = useForm();

  const getUserRoleMutation = useMutation(getUserRole, {
    onSuccess: (data) => {
      setItem(localStorageKey.userRole, data?.data?.userRole);
      navigate(allRoutes.dashboard);
    }
  });

  const loginMutation = useMutation(loginUser, {
    onSuccess: (data) => {
      handleOnSuccess(data);
    },
    onError: (error) => {
      handleOnError(error);
    }
  });

  function handleOnSuccess(data) {
    setRecoil<AccountType | undefined>(accountAtom, {
      id: data?.user?.uid || "",
      emailId: data?.user?.email || "",
      profilePhoto: data?.user?.photoURL,
      name: data?.user?.displayName
    });
    getUserRoleMutation.mutate();
    toast.success(Strings.login_toast);
  }

  function handleOnError(e) {
    if (e.code === "auth/user-not-found") {
      return toast.error(Strings.user_not_found);
    } else if (e.code === "auth/wrong-password") {
      return toast.error(Strings.password_incorrect);
    } else if (e.code === "auth/user-disabled") {
      return toast.error(Strings.your_account_disable);
    } else if (e.code === "auth/invalid-login-credentials") {
      return toast.error(Strings.invalid_cred);
    } else return { success: false, message: e.message };
  }
  function onSubmit(data) {
    const { email, password } = data;
    loginMutation.mutate({ email, password });
  }

  return (
    <div className="login">
      <AuthForm title={Strings.login}>
        <Form>
          <LoginForm control={control} />
          <div className="form-link">
            <Link to={allRoutes.forgotPassword} data-cy="forgot-password">
              {Strings.forgot_pass_title}?
            </Link>
          </div>
          <Button
            title={Strings.login}
            variant="primary"
            fullWidth
            onClick={handleSubmit(onSubmit)}
            isLoading={loginMutation?.isLoading}
            disabled={loginMutation?.isLoading}
            dataCy="loginButton"
          />
        </Form>
      </AuthForm>
    </div>
  );
}

export default Login;
